import { inject, provideAppInitializer } from '@angular/core';
import { AppVersionRefreshHandlerService } from './app-version-refresh-handler.service';

/**
 * Provides the app version refresh handler service and initializes it on app startup.
 * Add this to your app.config.ts providers array.
 *
 * @example
 * ```ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     // ... other providers
 *     provideAppVersionRefreshHandler()
 *   ]
 * };
 * ```
 */
export function provideAppVersionRefreshHandler() {
  return provideAppInitializer(() => {
    const service = inject(AppVersionRefreshHandlerService);
    service.initialize();
  });
}
